module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.261c6193.eot";